module.exports = __webpack_public_path__ + "static/media/footer_follow_black.b5a83485.png";